import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HomeRedirectGuard {

  constructor(private router: Router) {}

  canActivate(): UrlTree {
    return this.router.createUrlTree(
      ['orders', 'list-orders'],
      {
        queryParams: {
          externalOrderId: 'not_null'
        }
      }
    );
  }
}
